import { render, staticRenderFns } from "./commenInfo.vue?vue&type=template&id=0186ff4e"
import script from "./commenInfo.vue?vue&type=script&lang=js"
export * from "./commenInfo.vue?vue&type=script&lang=js"
import style0 from "./commenInfo.vue?vue&type=style&index=0&id=0186ff4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports